import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import { startErrorTracking } from './observability/error-tracking';
import './styles.css';
import { installFormFeedback } from './forms/feedback';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');
installFormFeedback();
void startErrorTracking();

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider><App /></AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
